/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SmyFullPopup from '@/components/SmyFullPopup';
import ViewBox from "vux/src/components/view-box/index.vue";
import Search from "vux/src/components/search/index.vue";
import AMap from 'AMap';
var map = {};
var marker = {};
var placeSearch = {};
var geocoder = {};
export default {
  name: 'GaoDeMap',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SmyFullPopup: SmyFullPopup,
    ViewBox: ViewBox,
    Search: Search
  },
  watch: {
    value: function value(val) {
      this.isShow = val;
    },
    isShow: function isShow(v) {
      var _this2 = this;

      if (v) {
        this.$DingTalk.biz.navigation.setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this2.isShow = false;
          }
        });
      } else {
        this.$DingTalk.biz.navigation.setLeft({
          control: false
        });
      }

      this.$emit('input', v);
    }
  },
  data: function data() {
    return {
      isShow: this.value,
      position: '',
      nowClickIndex: 0,
      isShowModal: false,
      madalLoading: true,
      center: [118.180987, 24.486432],
      nowAddress: '',
      searchKey: '',
      searchResult: [],
      cityList: [],
      selectCity: '',
      isClickMap: false,
      map: {}
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this = _this3;
              AMap.plugin('AMap.CitySearch', function () {
                var citysearch = new AMap.CitySearch();
                citysearch.getLocalCity(function (status, result) {
                  if (status === 'complete' && result.info === 'OK') {
                    _this.loadmap(result.city);
                  } else {
                    _this.loadmap();
                  }
                });
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    callback: function callback(arr, add) {
      this.$emit('callback', {
        position: arr,
        address: add
      });
      this.isShow = false;
    },
    loadmap: function loadmap(code) {
      var _this4 = this;

      var citycode = code || '全国';
      this.map = map = new AMap.Map('mymap', {
        resizeEnable: true,
        center: this.center,
        zoom: 13
      });
      AMap.plugin(['AMap.ToolBar', 'AMap.Scale', 'AMap.PlaceSearch', 'AMap.Marker', 'AMap.Geocoder', 'AMap.InfoWindow'], function () {
        map.addControl(new AMap.ToolBar());
        map.addControl(new AMap.Scale());
      });
      marker = new AMap.Marker({
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
        position: this.center // title: provinces[i].name

      });
      AMap.service('AMap.Geocoder', function () {
        // 实例化Geocoder
        geocoder = new AMap.Geocoder({
          city: citycode
        });
      });
      marker.setMap(map);
      this.getNowAddress();
      map.on('click', function (e) {
        _this4.isClickMap = true;
        _this4.searchResult = [];
        _this4.center = [e.lnglat.getLng(), e.lnglat.getLat()];
        marker.setPosition && marker.setPosition(_this4.center);
        map.panTo(_this4.center); // map.setFitView()

        _this4.getNowAddress();
      }); // 点击marker事件

      AMap.event.addListener(marker, 'click', function () {
        _this4.getNowAddress();
      });
      setTimeout(function () {
        placeSearch = new AMap.PlaceSearch({
          // 构造地点查询类
          // pageSize: 5,
          // pageIndex: 1,
          city: citycode // map: map
          // panel: 'panel'

        }); // 监听点击搜索结果标签事件

        AMap.event.addListener(placeSearch, 'markerClick', function (e) {
          _this4.center = [e.data.location.lng, e.data.location.lat];
          marker.setPosition && marker.setPosition(_this4.center);
          map.panTo(_this4.center);

          _this4.getNowAddress();
        });
      }, 1000); // 输入提示
    },
    // 根据地址获取地理编码
    getNowCode: function getNowCode(address) {
      geocoder.getLocation('address', function (status, result) {
        if (status === 'complete' && result.info === 'OK') {}
      });
    },
    seachAddress: function seachAddress() {
      var _this5 = this;

      AMap.service(['AMap.PlaceSearch'], function () {
        // 关键字查询
        placeSearch.search(_this5.position, function (status, result) {
          if (result.info === 'OK' || result.info) {
            if (result.poiList && result.poiList.pois && result.poiList.pois[0] && result.poiList.pois[0].location) {
              var data = result.poiList.pois[0].location;
              _this5.searchResult = result.poiList.pois;
              _this5.center = [data.lng, data.lat];
              marker.setPosition && marker.setPosition(_this5.center);
              map.panTo(_this5.center);

              _this5.getNowAddress();
            }
          } else {
            _this5.nowAddress = '未搜索到数据';
            _this5.searchResult = [];
          }
        });
      });
    },
    // 获取中心点的详细地址
    getNowAddress: function getNowAddress() {
      var _this6 = this;

      if (geocoder.getAddress) {
        // 地理编码返回详细地址
        geocoder.getAddress(this.center, function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            _this6.nowAddress = result.regeocode.formattedAddress;

            _this6.openInfo(_this6.nowAddress); // 获得了有效的地址信息:
            // 即，result.regeocode.formattedAddress

          } else {// 获取地址失败
            }
        });
      }
    },
    // 显示信息窗体
    openInfo: function openInfo(address) {// let infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) });
      // infoWindow.setContent(address);
      // infoWindow.open(map, this.center);
    }
  }
};